import React, { useContext } from 'react';
import FalconContext from '../contexts/falcon.context';

const SecondStageFlare = props => {
  const { className } = props;
  const falconState = useContext(FalconContext);
  const showStates = ['ses', 'seco'];
  const firstStageFlareImagePath = 'assets/rocket-flare.gif';

  return showStates.includes(falconState.state) ? (
    <img className={className} src={firstStageFlareImagePath} />
  ) : null;
};

export default SecondStageFlare;
